import * as React from "react";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";

/**
 * <a href> Link Component that is trackable using FlexClickTracker
 */
class Link extends React.Component<any, any> {
  public render() {
    return <a ref={this.props.setref} {...this.props} />;
  }
}

const TrackedLink = FlexClickTracker(Link);

export { TrackedLink };
